<template>
    <div>
        {{ $t('notification.taskWorkflowPipelineStageUpdated', { 
            actor: $_.get(activity, 'actorUser.name'), 
            workflowTitle: $_.get(activity, 'payload.workflowTitle'),
            stageName: $_.get(activity, 'payload.stageName')
        }) }}
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskWorkflowPipelineStageUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

